import { render, staticRenderFns } from "./MailBulkUnsetPostPackageView.vue?vue&type=template&id=6d20cf68&scoped=true"
import script from "./MailBulkUnsetPostPackageView.vue?vue&type=script&lang=js"
export * from "./MailBulkUnsetPostPackageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20cf68",
  null
  
)

export default component.exports